/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { ERC20Token__factory } from "./ERC20Token__factory";
